import {common_share} from '@/api/common.js';
import config2 from '@/static/js/config.js';
var jweixin = require('jweixin-module');
//定义配置参数
let config = {};

//获取配置参数
function get_wechat(url,title) {
	common_share({url:url}).then(res => {
		config = res.data.signPackage;
		init(url, title);
	});
}

function init(url, title) {
	let param = {
		debug: false, // 开启调试模式
		appId: config.appId, // 必填，公众号的唯一标识
		timestamp: config.timestamp, // 必填，生成签名的时间戳
		nonceStr: config.nonceStr, // 必填，生成签名的随机串
		signature: config.signature, // 必填，签名
		jsApiList: [
			'checkJsApi', //判断当前客户端版本是否支持指定JS接口
			'onMenuShareTimeline', //分享到朋友圈
			'onMenuShareAppMessage', //分享给好友
		] // 必填，需要使用的JS接口列表
	};

	jweixin.config(param);
	jweixin.ready(function () {
		// 分享到朋友圈
		jweixin.onMenuShareTimeline({
			title: title,
			link: config2.api.url + url,
			desc: '欢迎使用吉浦迅科技！',
			imgUrl:  require('@/static/image/logo.png'),
			type: 'link',
			dataUrl: '',
			success: function () {

			},
			cancel: function () {

			}
		});

		//分享给好友
		jweixin.onMenuShareAppMessage({
			title: title,
			link: config2.api.url + url,
			desc: '欢迎使用吉浦迅科技！',
			imgUrl:  require('@/static/image/logo.png'),
			success: function () {

			},
			cancel: function () {

			}
		});
	});
}

//执行入口
export function share(url,title) {
	get_wechat(url,title);
}